import { NFTEventInfo } from "@models/event";
import { memo } from "react";

const GOOGLE_MAP_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY || "";
const GOOGLE_URL = "https://www.google.com/maps";

const EventDetailMap = ({ info }: { info: NFTEventInfo }) => {
  if (!GOOGLE_MAP_API_KEY || !info.location) return <></>;
  const locationQuery = encodeURIComponent(
    info.locationQuery || info.location || ""
  );
  return (
    <div className="mb-6 w-full">
      <a
        tabIndex={-1}
        href={`${GOOGLE_URL}/search/?api=1&query=${locationQuery}`}
        className="rounded overflow-hidden block"
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        <iframe
          src={`${GOOGLE_URL}/embed/v1/place?key=${GOOGLE_MAP_API_KEY}&q=${locationQuery}`}
          className="flex w-full pointer-events-none"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </a>
    </div>
  );
};

export default memo(EventDetailMap);
